module.exports = __WEBPACK_EXTERNAL_MODULE_17__;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 17
// module chunks = 24 25